import React from 'react'
import Navbar from '../navbar/Navbar'
import Header from '../header/Header'
import Project from '../project/Project'
import Portfolio from '../Portfolio/Portfolio'
import About from '../aboutus/about'
import Footer from "../footer/Footer";

import Whychose from '../whychoose/Whychose'
import Waywework from '../waywework/Waywework'
import OurClient from "../our-client/Ourclient";
import Testimonials from '../testimonial/Testimonial'
// import ContactPopup from '../contact_popup/contactpopup'
// import Imagesall from '../imagesall/Imagesall'


function Interiorpage() {
  return (
    <>
    <Navbar/>
    <Header/>
    <Project/>
    <About/>
    <Portfolio/>
    {/* <Popupcontact/> */}
    <Whychose/>
    <Waywework/>
    {/* <Imagesall/> */}
    {/* <PopupContact/> */}
    {/* <ContactPopup/> */}
    <OurClient/>
    <Testimonials/>
    <Footer/>
    
    </>
  )
}

export default Interiorpage